import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RestService } from '../services/rest.service';
@Injectable({
  providedIn: 'root'
})
export class ShiftService {

  constructor(private restHttp: RestService) { }

  public getAllShiftsByCityId(cityId): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/GetShiftByCityId?cityId=${cityId}`);
  }
  public DeleteShift(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/DeleteShift?id=${id}`);
  }
  public AddShift(model: any) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/Shift`, model);
  }
  public UpdateShift(model: any) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/UpdateShift`, model);
  }
  getShiftbyId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/Shift/${id}`);
  }
  getDriverByShiftId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/GetDriversByShiftId?shiftId=${id}`);
  }
  getBatchByShiftId(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/BatchesByShiftId?shiftId=${id}`);
  }

}
